import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetCartQuery } from 'renderer/features/payments-page/services/cart.endpoints';
import { useCancelPaypalCheckoutMutation } from '../services/purchase.endpoints';

export default function PurchaseCancel() {
  const location = useLocation();
  const navigate = useNavigate();
  const [cancelPaypalCheckout] = useCancelPaypalCheckoutMutation();
  const { refetch: refetchCart } = useGetCartQuery(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const approval = JSON.parse(
      localStorage.getItem('paypalApproval') || 'null',
    );
    const cartId = params.get('cartId') || approval?.cartId;

    localStorage.removeItem('paypalApproval');

    const redirectToPurchase = () => {
      navigate('/purchase', {
        replace: true,
        state: {
          paypalCancelled: true,
          paymentProvider: 'paypal',
        },
      });
    };

    const unlockCart = async () => {
      try {
        await cancelPaypalCheckout(cartId ? { cartId } : {}).unwrap();
      } catch {
        // Still return the shopper to checkout even if unlock fails.
      } finally {
        await refetchCart();
        redirectToPurchase();
      }
    };

    unlockCart().catch(() => {
      // Errors are handled inside unlockCart.
    });
  }, [cancelPaypalCheckout, location.search, navigate, refetchCart]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <CircularProgress size={100} />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 2, fontStyle: 'italic' }}
      >
        Returning to checkout…
      </Typography>
    </Box>
  );
}
